import { render, staticRenderFns } from "./customerAnalyse.vue?vue&type=template&id=065f68fd&scoped=true&"
import script from "./customerAnalyse.vue?vue&type=script&lang=js&"
export * from "./customerAnalyse.vue?vue&type=script&lang=js&"
import style0 from "./customerAnalyse.vue?vue&type=style&index=0&id=065f68fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f68fd",
  null
  
)

export default component.exports